export function roundToTwoDecimals(value: number): number {
	return Math.round((value + Number.EPSILON) * 100) / 100;
}

export const onlyNumbers = (value: string): string => {
	return value.replace(/\D/g, '');
}

export const maskCpf = (value: string): string => {
	return onlyNumbers(value)
	  .slice(0, 11)
	  .replace(/(\d{3})(\d)/, '$1.$2')
	  .replace(/(\d{3})(\d)/, '$1.$2')
	  .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
}

export const maskCnpj = (value: string): string => {
	return onlyNumbers(value)
	  .slice(0, 14)
	  .replace(/^(\d{2})(\d)/, '$1.$2')
	  .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
	  .replace(/\.(\d{3})(\d)/, '.$1/$2')
	  .replace(/(\d{4})(\d)/, '$1-$2');
}

export const validateCPF = (cpf: string): boolean => {
	if (!cpf) return false;

	cpf = cpf.replace(/\D/g, "");

	if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;

	for (let j = 9; j <= 10; j++) {
		let soma = 0;

		for (let i = 0; i < j; i++) {
			soma += Number(cpf[i]) * (j + 1 - i);
		}

		let r = soma % 11;
		r = r < 2 ? 0 : 11 - r;

		if (r !== Number(cpf[j])) return false;
	}

	return true;
}

export const validateCNPJ = (cnpj: string): boolean => {
	if (!cnpj) return false;

	cnpj = cnpj.replace(/\D/g, "");
	if (cnpj.length !== 14 || /^(\d)\1+$/.test(cnpj)) return false;

	const calc = (base: string) => {
		let soma = 0;
		let peso = 2;

		for (let i = base.length - 1; i >= 0; i--) {
			soma += Number(base[i]) * peso;
			peso = peso === 9 ? 2 : peso + 1;
		}

		const resto = soma % 11;
		return resto < 2 ? 0 : 11 - resto;
	};

	const d1 = calc(cnpj.slice(0, 12));
	const d2 = calc(cnpj.slice(0, 12) + d1);

	return cnpj.endsWith(`${d1}${d2}`);
}
